<script context="module">
	export const boxes = [
		{
			title: {
				text: 'web.photovoltaics.region.stripe.box1.heading'
			},
			description: 'web.photovoltaics.region.stripe.box1.text',
			icon: {
				src: '/images/icons/black-red/globe.svg',
				alt: 'web.photovoltaics.region.stripe.box1.imageAlt'
			},
			slot: `
        <div style="margin: 10px 0 0 0; text-align: left; gap: 5px; display: flex;">
          <img src="/images/icons/flag/de.svg" alt="Vlajka DE">
          <img src="/images/icons/flag/it.svg" alt="Vlajka IT">
          <img src="/images/icons/flag/pl.svg" alt="Vlajka PL">
          <img src="/images/icons/flag/cz.svg" alt="Vlajka CZ">
        </div>
      `
		},
		{
			title: {
				text: 'web.photovoltaics.region.stripe.box2.heading'
			},
			description: 'web.photovoltaics.region.stripe.box2.text',
			icon: {
				src: '/images/icons/black-red/money.svg',
				alt: 'web.photovoltaics.region.stripe.box2.imageAlt'
			}
		},
		{
			title: {
				text: 'web.photovoltaics.region.stripe.box3.heading'
			},
			description: 'web.photovoltaics.region.stripe.box3.text',
			icon: {
				src: '/images/icons/black-red/heart.svg',
				alt: 'web.photovoltaics.region.stripe.box3.imageAlt'
			}
		},
		{
			title: {
				text: 'web.photovoltaics.region.stripe.box4.heading'
			},
			description: 'web.photovoltaics.region.stripe.box4.text',
			icon: {
				src: '/images/icons/black-red/shield.svg',
				alt: 'web.photovoltaics.region.stripe.box4.imageAlt'
			}
		}
	]
</script>

<script>
	import { sendGTM } from '$lib/analytics'
	import Header from '$lib/components/header-2.0/Header.svelte'
	import { URLPART_TYPE_LISTING } from '$lib/consts'
	import { OtherArticlesV4 } from '$lib/modules/blog'
	import ReferenceItems from '$lib/modules/references/ReferenceItems.svelte'
	import { PHOTOVOLTAICS, WOLTADVISOR, MEETING, MARKETPLACE } from '$lib/routes'
	import { t } from '$lib/translations'
	import { Breadcrumbs, FAQ, IconedBoxes } from '$lib/ui-woltair/components'

	export let data

	export const header = {
		heading: t('web.global.photovoltaicsPlural'),
		subheading: t('web.photovoltaics.header.referencesSubheading'),
		references_subtext: t('web.photovoltaics.header.referencesSubtext', { link: '' })
	}
</script>

<section class="page-fullwidth bg-neutral-100">
	<Breadcrumbs regionName={data.regionName} deviceType="fotovoltaika" />
</section>

<Header
	{header}
	regionName={data.regionName}
	references={data.references}
	showReferences={data.featureConfig.references.pv}
>
	<svelte:fragment slot="buttonArea">
		<div class="relative">
			{#if data.featureConfig.woltadvisor.pv}
				<div class="flex pt-8 md:-mt-2-res md:pt-16">
					<a
						class="btn btn-filled-primary text-base-res"
						href="/{PHOTOVOLTAICS}/{WOLTADVISOR}"
						data-testid="calculator">{t('web.photovoltaics.header.calculator.text')}</a
					>

					<div class="relative hidden min-h-full w-full md:block">
						<img
							src="/images/icons/arrow-handdrawn.svg"
							alt=""
							class="absolute bottom-8 right-3/4 max-h-8 w-1/5"
						/>
						<img
							src="/images/misc/head-offer-pv.webp"
							alt=""
							class="absolute -bottom-2 right-0 max-h-28 w-8/12 object-contain md:-top-12"
						/>
					</div>
				</div>
			{/if}
			{#if data.featureConfig.meeting.pv}
				<div>
					<a
						class="btn btn-outline-accent-red wrap relative z-10 mt-4 text-base-res"
						href="/{PHOTOVOLTAICS}/{MEETING}"
						data-testid="meeting"
						on:click={() => sendGTM('online_meet')}
						>{t('web.heat_pump.header.meeting.text')}
						<img
							class="ml-6-res hidden sm:block sm:scale-150"
							src="/images/avatars/team.webp"
							alt={t('web.heat_pump.header.meeting.img.alt')}
						/>
					</a>
				</div>
			{/if}
		</div>
	</svelte:fragment>
	<svelte:fragment slot="bottom">
		{#if data.cities.data?.length && data.slug !== 'praha'}
			<div class="mt-4 text-center">
				<h4 class="mb-8 font-semibold">{t('web.photovoltaics.region.byCity')}:</h4>
				<div class="page-wrapper max-w-xl text-center">
					{#each data.cities.data as city, _index}
						{#if _index < 5}
							<a
								class="mb-4 mr-4 inline-block rounded-lg bg-white p-4 text-neutral-800 shadow-lg hover:text-primary-500"
								href={`/${MARKETPLACE}/${URLPART_TYPE_LISTING['pv']}/${city.attributes.slug}?formType=pv&cityName=${city.attributes.zip}&cityNameReal=${city.attributes.name}`}
							>
								{city?.attributes.name}
							</a>
						{:else if _index === 5}
							<details class="detail inline">
								<summary class="cursor-pointer">
									<div
										class="mb-4 mr-4 rounded-lg bg-white p-4 text-neutral-800 shadow-lg hover:text-primary-500"
									>
										{t('web.global.loadMore')}
									</div>
								</summary>
								{#each data.cities.data.slice(_index) as city}
									<a
										class="mb-4 mr-4 inline-block rounded-lg bg-white p-4 text-neutral-800 shadow-lg hover:text-primary-500"
										href={`/${MARKETPLACE}/${URLPART_TYPE_LISTING['pv']}/${city.attributes.slug}`}
									>
										{city?.attributes.name}
									</a>
								{/each}
							</details>
						{/if}
					{/each}
				</div>
			</div>
		{/if}
	</svelte:fragment>
</Header>

<section class="page-wrapper my-10">
	<IconedBoxes {boxes} subtext cls="my-5" itemsConfig={{ width: '320px' }} />
</section>
<section class="page-wrapper">
	<ReferenceItems
		references={data.references}
		regionName={data.regionName}
		deviceType="fotovoltaika"
		title="Reference pro fotovoltaiky -"
		cls="mt-5"
	/>
</section>
{#if data.faqs}
	<section class="page-wrapper relative mt-24">
		<FAQ faqs={data.faqs} />
	</section>
{/if}
{#if data.otherArticles}
	<section class="page-wrapper">
		<OtherArticlesV4 otherArticles={data.otherArticles} />
	</section>
{/if}

<style lang="scss">
	details {
		summary {
			list-style: none;
		}
		&[open] {
			summary::-webkit-details-marker,
			summary::marker {
				display: none;
			}
			summary div {
				display: none;
			}
		}
	}
</style>
